export const asset = (path) => {
  const prefix = document.head.querySelector('meta[name="asset-url"]').content

  return prefix.replace(/\/+$/, '') + '/' + path.replace(/^\/+/, '')
}
